module.exports = __webpack_public_path__ + "img/icon-exit.7845d9a0.svg";